import { DataPolicyProps } from '../../services/DataPolicyService';

interface DataPolicyModalProps {
  isModalOpen: boolean;
  setIsModalOpen: (value: boolean) => void;
  dataPolicy: DataPolicyProps;
}

export const DataPolicyModal = ({ isModalOpen, setIsModalOpen, dataPolicy }: DataPolicyModalProps) => {
  return (
    <div className={`fixed inset-0 z-[100] w-full h-full ${isModalOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'}`} style={{ transitionDelay: '0.2s' }}>
      <div className='flex items-center justify-center mt-12 mx-auto h-4/5 min-[350px]:w-[95%] md:w-[85%] min-[1600px]:w-[60%] min-[350px]:px-2 sm:px-4 text-center'>
        {/* Background overlay */}
        <div className='absolute inset-0 bg-black opacity-70' onClick={() => setIsModalOpen(false)}></div>
        {/* Modal overlay */}
        <div
          className='inline-block h-full align-top bg-white rounded-lg text-left overflow-y-auto shadow-xl transform transition-all w-full'
          onClick={(e) => e.stopPropagation()}
          style={{ transition: 'transform 0.4s ease-in-out', transform: isModalOpen ? 'translateY(0)' : 'translateY(-100%)' }}
        >
          {/* Modal content */}
          <div className='bg-white w-full h-full text-center'>
            {/* Modal header */}
            <div className='min-[350px]:h-[10%] lg:h-[5%] items-center px-3 min-[350px]:py-4 md:py-2 w-full flex justify-between md:overflow-auto  lg:overflow-hidden  border-b-2 border-gray-300'>
              <h1 className='text-lg font-medium text-gray-900'>{dataPolicy.title}</h1>
              <h1 className='cursor-pointer' onClick={() => setIsModalOpen(false)}>
                x
              </h1>
            </div>
            {/* Modal body */}
            <div className='min-[350px]:h-[90%] lg:h-[95%] min-[350px]:px-5 lg:px-0 overflow-auto'>
              <div dangerouslySetInnerHTML={{ __html: dataPolicy.renderedView }} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
